import { isWithinInterval } from 'date-fns';
import { fromZonedTime } from 'date-fns-tz';

export type SimpleTime = [hours: number, minutes: number];

export interface TimeRange {
  start: SimpleTime;
  end: SimpleTime;
}

export type BusinessHours = {
  [key: number]: TimeRange | null;
};

export const ETtimezone = 'America/New_York';

export function isWithinBusinessHours(businessHours: BusinessHours): boolean {
  const now = new Date();
  const businessHoursForDay = businessHours[now.getDay()];

  if (!businessHoursForDay) return false;

  let endDay = now.getDate();
  let endMonth = now.getMonth();
  let endYear = now.getFullYear();
  if (businessHoursForDay.end[0] < businessHoursForDay.start[0]) {
    endDay += 1;
    const daysInMonth = new Date(endYear, endMonth + 1, 0).getDate();
    if (endDay > daysInMonth) {
      endDay = 1;
      endMonth += 1;
      if (endMonth > 11) {
        endMonth = 0;
        endYear += 1;
      }
    }
  }
  const start = fromZonedTime(
    new Date(now.getFullYear(), now.getMonth(), now.getDate(), ...businessHoursForDay.start),
    ETtimezone,
  );
  const end = fromZonedTime(
    new Date(endYear, endMonth, endDay, ...businessHoursForDay.end),
    ETtimezone,
  );

  return isWithinInterval(now, { start, end });
}
